module.exports = __webpack_public_path__ + "static/media/sword-min.1b41f8c2.svg";